export const TOKEN_KEY = 'token';
export const SESSION_INFO_KEY = 'infoSession';
export const BEARER_PREFIX = 'Bearer';
